
import { ExtraButton, ExtraButtonLocation, getExtraButtonLocationAsSelectItems } from "@/models/extra-button";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			button: new ExtraButton()
		};
	},
	props: {
		value: {
			type: Object as ()=>ExtraButton,
			required: true
		},
	},
	computed: {
		locationItems():ISelectItem<ExtraButtonLocation>[]{
			return getExtraButtonLocationAsSelectItems();
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.button = new ExtraButton(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			this.$emit("input", this.button);
			this.close();
		}
	},
});
